import { render, staticRenderFns } from "./PageShowsCalendar.vue?vue&type=template&id=36dac71c&"
import script from "./PageShowsCalendar.vue?vue&type=script&lang=js&"
export * from "./PageShowsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports